// extracted by mini-css-extract-plugin
export default {"container":"FormSectionHeader_container__Nm4yi"};